import t from "../../../helpers/t";
import {moment} from "../../../../../vendor";
import React from "react";
import {getUserNameById} from "../../tasks/components/Functions";

const ResourcesView = (props) => {
    let isCartView = props.isCartView;
    let resources = props.resources;
    let isStepCheckout = props.isStepCheckout;
    return(
        <>
            {resources.length >= 1 && resources.filter(function(resource) {
                if(isCartView && typeof props._checkin.selectedResources[Number(resource.id)] !== 'undefined'){
                    return true;
                } else if (isCartView && typeof props._checkin.selectedResources[Number(resource.id)] === 'undefined'){
                    return false;
                }
                return !(!isCartView && typeof props._checkin.selectedResources[Number(resource.id)] !== 'undefined');
            }).map(resource => {
                console.log(props._checkin.selectedResources[Number(resource.id)])
                let element = <><>
                    <div className="inb-resource inb-c-item-details-row row" data-inb-resource-id={resource.id}>
                        <div className="medium-1 small-3 column inb-resource__id" style={{minHeight: "40px"}}>
                            #{resource.id}
                        </div>
                        <div className="medium-3 small-6 column inb-resource__name">
                            {resource.name}
                            {resource.name === '' && (resource.mac === '' || resource.mac === null) &&
                                <i>{t('resource_not_configured_yet')}</i>}
                        </div>

                        <div className="medium-2 small-3 column inb-resource__mac"
                             title={t('external_resource_id')}>
                            {resource.external_resource_id}
                        </div>

                        <div className="medium-3 small-6 column">
                            {isCartView &&
                                <>
                                    {isStepCheckout === false && <><input
                                        type="text"
                                        className={"checkin-comment"}
                                        value={''}
                                        placeholder={t('checkin_comment_placeholder')}
                                    /></>}
                                    {isStepCheckout && <><input
                                        type="text"
                                        className={"checkin-comment"}
                                        disabled
                                        value={typeof props._checkin.selectedResources[Number(resource.id)] !== 'undefined' && props._checkin.selectedResources[Number(resource.id)].comment_checkin !== null ? props._checkin.selectedResources[Number(resource.id)].comment_checkin : ''}
                                        placeholder={t('checkin_comment_placeholder')}
                                    /></>}
                                </>
                            }
                            {isStepCheckout &&
                                <>
                            <span>
                            <i className="fi fi-check"> </i>
                                {t('checkin_single_resource_done') + " " + t('day_on') + " " +
                                    moment(typeof props._checkin.selectedResources[Number(resource.id)] !== 'undefined' && props._checkin.selectedResources[Number(resource.id)].checkin).format('Do MMMM YYYY, HH:mm') + " "}
                                in
                                {" " + props._checkin.selectedResources[Number(resource.id)].location_checkin_name}
                                { " " +t('edited_by') + " "}
                                {props._checkin.selectedResources[Number(resource.id)].created_by_name}
                            </span>
                                </>
                            }
                        </div>

                        <div className="medium-3 small-6 column text-right">
                            {isStepCheckout === false &&
                                <>
                                    <a className="inb-resource__checkinout_action" href="#" onClick={() => {
                                        props.onItemClickHandler(resource)
                                    }}>
                                        {isCartView &&
                                            t('checkin_remove_from_selection')
                                        }
                                        {isCartView === false &&
                                            <i className="fi fi-check" title={t('checkin_add_to_selection')}> </i>}
                                    </a>
                                </>
                            }
                            {isStepCheckout && isCartView === false &&
                                <>
                                    <input
                                        type="text"
                                        className={"checkin-comment"}
                                        disabled
                                        value={props._checkin.comment_checkin !== null ? props._checkin.comment_checkin : ''}
                                        placeholder={t('checkin_comment_placeholder')}
                                        onChange={(e) => {
                                            props._changeCommentCheckin(e)
                                        }}
                                    /></>}

                            {typeof props._checkin.selectedResources[Number(resource.id)] !== 'undefined' && props._checkin.selectedResources[Number(resource.id)].is_checked_out && <>
                                <input
                                    type="text"
                                    className={"checkout-comment"}
                                    disabled
                                    value={props._checkin.comment_checkout !== null ? props._checkin.comment_checkout : ''}
                                    placeholder={t('checkout_comment_placeholder')}
                                    onChange={(e) => {
                                        props._changeCommentCheckOut(e)
                                    }}
                                /></>}
                            {typeof props._checkin.selectedResources[Number(resource.id)] !== 'undefined' && !props._checkin.selectedResources[Number(resource.id)].is_checked_out && props.isStepCheckout && <>
                                <input
                                    type="text"
                                    className={"checkout-comment"}
                                    value={props._checkin.comment_checkout !== null ? props._checkin.comment_checkout : ''}
                                    placeholder={t('checkout_comment_placeholder')}
                                    onChange={(e) => {
                                        props._changeCommentCheckOut(e)
                                    }}
                                /></>}

                            {typeof props._checkin.selectedResources[Number(resource.id)] !== 'undefined' && !props._checkin.selectedResources[Number(resource.id)].is_checked_out && props.isStepCheckout &&
                                <>
                                    <a
                                        href="#"
                                        className="single-checkout hide">
                                        {t('checkout_single_resource')}
                                    </a>
                                </>
                            }
                            {typeof props._checkin.selectedResources[Number(resource.id)] !== 'undefined' && props._checkin.selectedResources[Number(resource.id)].is_checked_out &&
                                <>
                            <span>
                            <i className="fi fi-check"> </i>
                                {
                                    t('checkout_single_resource_done') + " " + t('day_on') + " " + (typeof props._checkin.selectedResources[Number(resource.id)] !== 'undefined' ? moment(props._checkin.selectedResources[Number(resource.id)].checkout).format('Do MMMM YYYY, HH:mm') + " " : "")}
                                in
                                {" " + props._checkin.selectedResources[Number(resource.id)].location_checkout_name}
                                { " " +t('edited_by') + " "}
                                {props._checkin.selectedResources[Number(resource.id)].modified_by_name}
                            </span>
                                </>
                            }
                        </div>
                    </div>
                </>
                </>;
                return element;
        })
    }
      </>
    );
}

export default ResourcesView;